import {
  useLocalStorage,
  useReadLocalStorage,
} from '@/lib/local-storage/local-storage';
import { useSession } from '@/providers/session-provider';
import { GLOBAL_FILTER_DEFAULT_VALUES, GLOBAL_FILTER_KEY } from '../constants';
import type { GlobalFilter } from '../types';

export function useGlobalFilter(): {
  globalFilter: GlobalFilter[string];
  setGlobalFilter: (value: GlobalFilter[string]) => void;
  clearGlobalFilter: () => void;
} {
  const {
    data: {
      session: { organizationId },
    },
  } = useSession();
  const [filter, setFilter] = useLocalStorage<GlobalFilter>({
    key: GLOBAL_FILTER_KEY,
    version: 1,
    defaultValue: {
      [organizationId]: GLOBAL_FILTER_DEFAULT_VALUES,
    },
  });

  function setGlobalFilter(value: GlobalFilter[string]) {
    setFilter((prev) => ({ ...prev, [organizationId]: value }));
  }

  function clearGlobalFilter() {
    setFilter((prev) => ({
      ...prev,
      [organizationId]: GLOBAL_FILTER_DEFAULT_VALUES,
    }));
  }

  return {
    globalFilter: filter?.[organizationId] ?? GLOBAL_FILTER_DEFAULT_VALUES,
    setGlobalFilter,
    clearGlobalFilter,
  };
}

export function useReadGlobalFilter(): GlobalFilter[string] {
  const {
    data: {
      session: { organizationId },
    },
  } = useSession();
  const value = useReadLocalStorage<GlobalFilter>({
    key: GLOBAL_FILTER_KEY,
    version: 1,
    defaultValue: {
      [organizationId]: GLOBAL_FILTER_DEFAULT_VALUES,
    },
  });
  return value?.[organizationId] ?? GLOBAL_FILTER_DEFAULT_VALUES;
}
